"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@headlessui/react");
var Icon_1 = require("../Icon");
var classnames_1 = require("classnames");
var Accordion = function (_a) {
    var className = _a.className, options = _a.options, dataTestID = _a["data-testid"];
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: className, "data-testid": dataTestID }, { children: options.map(function (option, optionIdx) { return ((0, jsx_runtime_1.jsx)(react_1.Disclosure, __assign({ as: "div", className: (0, classnames_1.default)('squid-border-b', option.className) }, { children: function (_a) {
                var open = _a.open;
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_1.Disclosure.Button, __assign({ className: (0, classnames_1.default)('squid-flex', 'squid-justify-between', 'squid-text-start', 'squid-w-full', 'squid-my-8', option.buttonClassName) }, { children: [option.title, (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: open ? 'ChevronUp' : 'ChevronDown' })] })), (0, jsx_runtime_1.jsx)(react_1.Disclosure.Panel, __assign({ className: (0, classnames_1.default)('squid-pb-4', option.panelClassName) }, { children: option.child }))] }));
            } }), "Disclosure-".concat(optionIdx))); }) })));
};
exports.Accordion = Accordion;
exports.Accordion.defaultProps = {};
